import React from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Box from '@material-ui/core/Box';
import Info from 'components/Tooltip/Info';
import { AmountValue } from 'common/interfaces';
import useStyles from './styles';
import { formatAmountValue, fractionToPercent } from 'helpers/helpers';
import { Currency } from 'enums';

interface Props {
  text: string;
  detail?: string;
  currency?: Currency;
  fee?: AmountValue;
  rate?: number;
  value?: string;
  tooltip?: React.ReactElement;
  className?: string;
  longValue?: boolean;
  max?: boolean;
  decimals?: number;
}

const SingleFeeItem: React.FC<Props> = ({
  text,
  detail,
  currency,
  fee,
  rate,
  value,
  tooltip,
  className,
  longValue,
  max,
  decimals
}) => {
  const classes = useStyles({});
  const { t } = useTranslation();
  return (
    <ListItem
      className={`${classes.itemBetween} ${className ? className : ''}`}
    >
      <Box className={classes.box}>
        <ListItemText secondary={detail}>{text}</ListItemText>
        {fee !== undefined && currency && (
          <ListItemText
            className={classes.singleFee}
            primary={formatAmountValue(fee.value, currency)}
          />
        )}
        {rate !== undefined && (
          <ListItemText className={classes.singleFee} primary={`${max ? t('general_max')+' ' :''}${fractionToPercent(rate, rate > 0 ? decimals || 1 : 0)}`} />
        )}
        {value && (
          <ListItemText
            className={`${classes.singleFee} ${longValue ? classes.singleFeeLong : ''}`}
            primary={value}
          />
        )}
      </Box>
      {tooltip ? <Info content={tooltip} tooltipProps={{ placement: 'bottom-start' }} /> : <span/>}
    </ListItem>
  );
};

export default SingleFeeItem;
